var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "modal-content",
      attrs: {
        title: _vm.title,
        width: 650,
        visible: _vm.visible,
        footer: null,
      },
      on: { cancel: _vm.hideModal },
    },
    [
      _c("div", { staticStyle: { "min-height": "300px" } }, [
        _c("div", { domProps: { innerHTML: _vm._s(_vm.richText) } }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }